import {randomId,View} from "vritra";
import css from "./ProduceBasket.module.css";
import ProduceView from "../ProduceView/ProduceView";


export default function ProduceBasket(props){
    const {parent,id=randomId("producebasket"),items}=props;
    const producebasket=View({parent,id,className:[css.producebasket,props.className]});

    producebasket.innateHTML=`
    `;
    items.forEach(item=>{
        ProduceView({parent:producebasket,produce:item});
    });

    return producebasket;
}
